import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';
import moment from 'moment';

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {}
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayatjabatan"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Detail Rwiayat Jabatan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Rwiayat Jabatan
                                    </CardSubtitle>
                                    <hr />

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                          No SK
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_history_decree_number !== "" ? this.state.detail.position_history_decree_number : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Tanggal SK
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_history_decree_date !== "" ? this.dateParse(this.state.detail.position_history_decree_date) : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Nama Jabatan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_name !== "" ? this.state.detail.position_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        TMT Mulai Jabatan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_history_tmt_position_date !== "" ? this.dateParse(this.state.detail.position_history_tmt_position_date) : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        TMT Berakhir Jabatan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_history_end_date_tmt !== "" ? this.dateParse(this.state.detail.position_history_end_date_tmt) : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Grade
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_grade !== "" ? this.state.detail.position_grade : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Eselon/Jenjang
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.echelon_name !== "" ? this.state.detail.echelon_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    {/* 

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Kode Eselon
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.echelon_code !== "" ? this.state.detail.echelon_code : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            TMT Eselon
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_history_tmt_echelon_date !== "" ? this.dateParse(this.state.detail.position_history_tmt_echelon_date) : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row> */}

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Pejabat Penetap
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_history_signatories_official !== "" ? this.state.detail.position_history_signatories_official : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>


                                    {/* <Row className="mb-3">
                                        <label className="col-md-3">
                                            No Pelantikan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_history_inauguration_number !== "" ? this.state.detail.position_history_inauguration_number : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Tanggal Pelantikan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_history_inauguration_date !== "" ? this.dateParse(this.state.detail.position_history_inauguration_date) : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                        Tunjangan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_history_allowance !== "" ? this.state.detail.position_history_allowance : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row> */}

                                    {/* <Row className="mb-3">
                                        <label className="col-md-3">
                                            Bulan Dibayar
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_history_allowance_pay_month !== "" ? this.state.detail.position_history_allowance_pay_month : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row> */}

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Unit Kerja Asal
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.work_unit_name_first !== "" ? this.state.detail.work_unit_name_first : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>


                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Unit Kerja Tujuan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.work_unit_name_end !== "" ? this.state.detail.work_unit_name_end : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Status Jabatan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.position_history_status_name !== "" ? this.state.detail.position_history_status_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to="/kepegawaian/home.html?riwayatjabatan" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                    
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);